import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  useDisclosure,
  IconButton,
  DrawerFooter,
  Button,
  List,
  ListItem,
  ListIcon,
} from "@chakra-ui/react";
import { PRIMARY_COLOR } from "helpers/constants";
import {
  MdDashboard,
  MdInventory,
  MdLogout,
  MdMenu,
  MdReceiptLong,
  MdSwapHoriz,
} from "react-icons/md";
import { Link } from "react-router-dom";
import useUser from "./hooks/useUser";
import { logout } from "helpers/utils";

export default function Menu() {
  const disclosure = useDisclosure();
  const { role } = useUser();

  return (
    <>
      <IconButton
        icon={<MdMenu size={28} />}
        aria-label="Menu"
        onClick={disclosure.onOpen}
      />
      <Drawer {...disclosure} placement="left">
        <DrawerOverlay />
        <DrawerContent bg={PRIMARY_COLOR} color="white">
          <DrawerCloseButton />
          <DrawerHeader>Menu</DrawerHeader>
          <DrawerBody
            onClick={(e) => {
              e.stopPropagation();
              disclosure.onClose();
            }}
          >
            <List spacing={3} fontSize={20}>
              {["Admin", "Super Admin", "QC"].includes(role.name) && (
                <ListItem display="flex" alignItems="center" as={Link} to={"/"}>
                  <ListIcon as={MdDashboard} />
                  Quick Info
                </ListItem>
              )}
              {["Admin", "Super Admin"].includes(role.name) && (
                <ListItem
                  display="flex"
                  alignItems="center"
                  as={Link}
                  to={"/items"}
                >
                  <ListIcon as={MdInventory} />
                  Items
                </ListItem>
              )}
              <ListItem
                display="flex"
                alignItems="center"
                as={Link}
                to={"/requests"}
              >
                <ListIcon as={MdReceiptLong} />
                Requests
              </ListItem>
              {["Admin", "Super Admin", "QC"].includes(role.name) && (
                <ListItem
                  display="flex"
                  alignItems="center"
                  as={Link}
                  to={"/transfers"}
                >
                  <ListIcon as={MdSwapHoriz} />
                  Transfers
                </ListItem>
              )}
            </List>
          </DrawerBody>
          <DrawerFooter>
            <Button
              variant="outline"
              onClick={logout}
              leftIcon={<MdLogout />}
              w="100%"
            >
              Logout
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
